import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from './Logo';
import SearchBox from './SearchBox';

const Navigation: React.FC = () => {
  const location = useLocation();

  return (
    <>
      <nav className="nav">
        <div className="container">
          <div className="nav-content">
            {/* Brand section */}
            <Link to="/" className="nav-brand">
              <Logo size="medium" />
              <div className="brand-text">
                <span className="brand-title">Democracy Renaissance</span>
                <span className="brand-subtitle">Government Transparency</span>
              </div>
            </Link>
            
            {/* Navigation links */}
            <ul className="nav-links">
              <li>
                <Link 
                  to="/" 
                  className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
                >
                  Home
                </Link>
              </li>
              <li>
                <Link 
                  to="/documents" 
                  className={`nav-link ${location.pathname === '/documents' ? 'active' : ''}`}
                >
                  Epstein Files
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      
      {/* Search bar below navigation */}
      <div className="search-header">
        <div className="container">
          <div className="search-header-content">
            <SearchBox 
              placeholder="Search 22,689 documents..."
              size="large"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Navigation;